import { render, staticRenderFns } from "./RequestDetail.vue?vue&type=template&id=23dbe5dc&scoped=true"
import script from "@/components/request/RequestDetail/RequestDetail.ts?vue&type=script&lang=ts&external"
export * from "@/components/request/RequestDetail/RequestDetail.ts?vue&type=script&lang=ts&external"
import style0 from "@/components/request/RequestDetail/request-detail.scss?vue&type=style&index=0&id=23dbe5dc&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23dbe5dc",
  null
  
)

export default component.exports